import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { SignIn } from "components/organisms/signin";
import { SignUp } from "components/organisms/signup";
import { ForgotPassword } from "components/organisms/forgot-password";
// import { Profile } from "components/organisms/profile";
import { Preferences } from "components/organisms/preferences";
import { PartnerSignUp } from "components/organisms/which-signup";
import { PageNotFound } from "components/organisms/page-not-found";
import { CoconutRedirect } from "components/organisms/coconut-redirect";
import ActivationPage from "components/organisms/activation-page";
import { ResendActivationCode } from "components/organisms/resend-activation-code";

export const Routes = () => (
  <Switch>
    <Route exact path="/" render={() => <Redirect to="/signin" />} />
    <Route path="/signin">
      <SignIn />
    </Route>
    <Route path="/signup">
      <SignUp />
    </Route>
    <Route path="/forgot-password">
      <ForgotPassword />
    </Route>
    {/* To remove edit profile page in account service */}
    {/* <Route path="/profile">
      <Profile />
    </Route> */}
    {/* End remove edit profile page in account service */}
    <Route path="/preferences">
      <Preferences />
    </Route>
    <Route path="/which">
      <PartnerSignUp />
    </Route>
    <Route path="/coconut/redirect_to_gosimpletax">
      <CoconutRedirect />
    </Route>
    <Route path="/account/:activationCode/activate">
      <ActivationPage />
    </Route>
    <Route path="/resend-activation">
      <ResendActivationCode />
    </Route>
    <Route
      path="/redirect-to-simpletax-terms"
      component={() => {
        window.location.href = "https://www.gosimpletax.com/terms/";
      }}
    ></Route>
    <Route path="*">
      <PageNotFound />
    </Route>
  </Switch>
);
